import { render, staticRenderFns } from "./PontosAvulso.vue?vue&type=template&id=75bfee19&lang=pug&"
import script from "./PontosAvulso.vue?vue&type=script&lang=js&"
export * from "./PontosAvulso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports